import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "filterItemsWrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "checkboxItem" }
const _hoisted_4 = ["id", "onChange", "checked"]
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagGroups, (taxonomy, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "filterItem",
        key: taxonomy.id
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["filterItemTitle", _ctx.selectedTaxonomyIndex === index && 'panelActive']),
          onClick: ($event: any) => (_ctx.showHideTaxonomy(index))
        }, [
          _createTextVNode(_toDisplayString(taxonomy.title) + " ", 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "arrow" }, null, -1))
        ], 10, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(["filterItemContent", _ctx.selectedTaxonomyIndex === index && 'panelActive'])
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxonomy.tags, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.id
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: option.id,
                    onChange: ($event: any) => (_ctx.selectTag(taxonomy.id, option)),
                    checked: 
                  _ctx.selectedTags.filter((t) => t.id === option.id).length > 0
                ,
                    onKeypress: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                  }, null, 40, _hoisted_4),
                  _createElementVNode("label", {
                    for: option.id
                  }, _toDisplayString(option.title), 9, _hoisted_5)
                ])
              ]))
            }), 128))
          ])
        ], 2)
      ]))
    }), 128))
  ]))
}